<template>
  <el-card
    :key="`${index}-routecard`"
    style="margin-bottom: 30px;"
  >
    <div
      slot="header"
      style="font-weight: 600;"
    >
      #{{ index + 1 }} Bolt
      <el-button
        :key="`${index}-routeitem-button`"
        style="float: right; margin-top: -6px;"
        type="danger"
        size="mini"
        icon="el-icon-remove"
        @click="removeShop()"
      >
        Törlés
      </el-button>
    </div>
    <el-form
    >
      <el-form-item
        prop="shop"

      >
        <el-select
          :value="shop"
          filterable
          style="width: 100%;"
          value-key="id"
          @change="handleChange"
        >
          <el-option
            v-for="s in shops"
            :key="s.id"
            :value="s.id"
            :label="`${s.name} (${s.partner_name}) - ${s.postal_code} ${s.city}`"
          >
            <strong>{{ s.name }}</strong> ({{ s.partner_name }})
            <span
              style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
            >
                    <el-tag
                      size="mini"
                      type="info"
                    >
                      {{ s.postal_code }} {{ s.city }} {{ s.address }}
                    </el-tag>
                  </span>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
  export default {
    name: "ShopCard",
    props: ['shop', 'index', 'shops'],

    data() {
      return {
      }
    },

    methods: {
      removeShop()
      {
        this.$emit('remove')
      },

      handleChange(e) {
        this.$emit('select', e)
      }
    }
  }
</script>

<style scoped>

</style>
